module.exports = __webpack_public_path__ + "media/images/newpasspic-8ff4a97f.svg";